// The pill switcher drawn at all three bands of `#s05` -- "Feed / By
// category / By merchant / Inbox" -- shared by every Transactions view so
// the active tab is highlighted consistently instead of four ad hoc copies.
import { Link, useLocation } from 'react-router-dom';
import { scopeHref } from '@/app/shell/scope';

const TABS = [
  { href: '/transactions', label: 'Feed' },
  { href: '/transactions/categories', label: 'By category' },
  { href: '/transactions/merchants', label: 'By merchant' },
  { href: '/transactions/inbox', label: 'Inbox' },
];

export function ViewSwitcher() {
  const { pathname, search, hash } = useLocation();
  return (
    <nav aria-label="Transactions views" className="my-3 flex flex-wrap gap-2 text-xs">
      {TABS.map((tab) => {
        const active = pathname === tab.href;
        return (
          <Link
            key={tab.href}
            to={scopeHref(`${tab.href}${hash}`, search)}
            aria-current={active ? 'page' : undefined}
            data-testid={`view-switcher-${tab.label.toLowerCase().replace(/\s+/g, '-')}`}
            className={[
              'ms-tap-44 inline-flex min-h-11 min-w-11 items-center justify-center font-medium',
            ].join(' ')}
          >
            <span
              className={[
                'inline-flex min-h-11 items-center rounded-full border px-3 py-1',
                active ? 'border-transparent bg-foreground text-background' : 'border-input bg-background text-foreground',
              ].join(' ')}
            >
              {tab.label}
            </span>
          </Link>
        );
      })}
    </nav>
  );
}

export default ViewSwitcher;
